module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-1-3829db08a46dc886bee4c2af321c7d6f.jpg";